import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Button, Form } from 'reactstrap'

import CustomSelect from '../../../CustomReactSelectComponent'
import InputGroup from '../../../InputGroup'
import InputWrapper from '../InputWrapper'

import { removeFilter } from '../redux/ContactFiltersActions'
import { EMAIL_TEMPLATE_FILTERS } from '../../../../constants/contactFilterCategory'
import { contactCategoryOptions } from '../../../../constants/contactCategory'
import { CARGO_CARRIED } from '../../../../constants/supportTypes'
import useGetSupportTable from '../../../../hooks/useGetSupportTable'
import { contactStatusesOptions } from '../../../../constants/statuses'
import CustomSwitch from '../../../CustomSwitch'
import { useSelector, useDispatch } from 'react-redux'
import { getDivisionsForCustomSelect } from '../../../../modules/Divisions/redux/DivisionActions'
import { IS_EXECUTIVE } from '../../../../constants/permissions'

const FilterInputsEmailTemplate = ({
  selectedFilters,
  handleFiltersChanges,
  loadData,
  selectedFiltersValues,
  getOptions,
  options,
  setFiltersValue,
}) => {
  const dispatch = useDispatch()
  // eslint-disable-next-line
  const { isExecutive, divisions } = useSelector((state) => ({
    isExecutive: state.auth.user.permissions.includes(IS_EXECUTIVE),
    divisions: state.divisions.divisionForSelect.filter((item) => item.id !== 1),
  }))

  // Cargo Carried lives in the support tables (same source the contact form uses),
  // not in the shared getOptions payload.
  const cargoCarriedOptions = useGetSupportTable(CARGO_CARRIED)

  useEffect(() => {
    getOptions(EMAIL_TEMPLATE_FILTERS)
    dispatch(getDivisionsForCustomSelect())
  }, [])

  const changeMultiSelect = (values, event) => {
    if (values && values.length) {
      const newValues = []
      values.forEach((value) => {
        newValues.push(value.id)
      })
      dispatch(setFiltersValue([event.name], newValues))
    } else {
      dispatch(removeFilter([event.name]))
    }
  }

  return (
    <>
      <Form noValidate onSubmit={() => loadData({ email_status: 1 })}>
        <Row className='mt-3 filterInputs'>
          {selectedFilters.address_city && (
            <InputWrapper md='3'>
              <Col md={12}>
                <InputGroup
                  label='City'
                  type='text'
                  name='address_city'
                  onChange={(event) => handleFiltersChanges(event)}
                  value={selectedFiltersValues.address_city}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.address_state && (
            <InputWrapper md='3'>
              <Col md={12}>
                <CustomSelect
                  label='State'
                  defaultValue={selectedFiltersValues.address_state || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'address_state')}
                  isMulti={false}
                  options={options.States || []}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.address_zip && (
            <InputWrapper md='3'>
              <Col md={6}>
                <InputGroup
                  label='Zip Code'
                  type='text'
                  name='address_zip'
                  onChange={(event) => handleFiltersChanges(event, 'zip', 'zip')}
                  value={selectedFiltersValues.address_zip?.zip}
                />
              </Col>
              <Col md={6}>
                <InputGroup
                  label='Radius'
                  type='number'
                  min={0}
                  name='address_zip'
                  onChange={(event) => handleFiltersChanges(event, 'zip', 'distance_radius')}
                  value={selectedFiltersValues.address_zip?.distance_radius}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.date_established && (
            <InputWrapper md='6'>
              <Col md={6}>
                <InputGroup
                  label='Date Established from'
                  name='date_established'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.date_established && selectedFiltersValues.date_established.from}
                />
              </Col>
              <Col md={6}>
                <InputGroup
                  label='Date Established to'
                  name='date_established'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.date_established && selectedFiltersValues.date_established.to}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.company_type_id && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Company Type'
                  defaultValue={selectedFiltersValues.company_type_id || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'company_type_id')}
                  isMulti={false}
                  options={options.CompanyType || []} // Need Company type
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.import_date && (
            <InputWrapper md='6'>
              <Col md={6}>
                <InputGroup
                  label='Import Date from'
                  name='import_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.import_date && selectedFiltersValues.import_date.from}
                />
              </Col>
              <Col md={6}>
                <InputGroup
                  label='Import Date to'
                  name='import_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.import_date && selectedFiltersValues.import_date.to}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.creation_date && (
            <InputWrapper md='6'>
              <Col md={6}>
                <InputGroup
                  label='Date Entered from'
                  name='creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.creation_date && selectedFiltersValues.creation_date.from}
                />
              </Col>
              <Col md={6}>
                <InputGroup
                  label='Date Entered to'
                  name='creation_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.creation_date && selectedFiltersValues.creation_date.to}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.estimated_revenue && (
            <InputWrapper md='6'>
              <Col md={6}>
                <InputGroup
                  label='Est. revenue from'
                  name='estimated_revenue'
                  type='number'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.estimated_revenue && selectedFiltersValues.estimated_revenue.from}
                />
              </Col>
              <Col md={6}>
                <InputGroup
                  label='Est. revenue to'
                  name='estimated_revenue'
                  type='number'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.estimated_revenue && selectedFiltersValues.estimated_revenue.to}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.organization_type_id && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Organization Type'
                  defaultValue={selectedFiltersValues.organization_type_id || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'organization_type_id')}
                  isMulti={false}
                  options={options.OrganizationType || []}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.contact_category && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Contact Category'
                  defaultValue={selectedFiltersValues.contact_category || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'contact_category')}
                  isMulti={false}
                  options={contactCategoryOptions || []}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.nationality_id && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Nationality'
                  defaultValue={selectedFiltersValues.nationality_id || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'nationality_id')}
                  isMulti={false}
                  options={options.Nationality || []}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.cargo_carried && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Cargo Carried'
                  // changeMultiSelect reads event.name, which react-select only
                  // provides when the Select carries a name.
                  name='cargo_carried'
                  defaultValue={selectedFiltersValues.cargo_carried || []}
                  onChange={changeMultiSelect}
                  isMulti={true}
                  options={cargoCarriedOptions}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.created_by && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Created By'
                  defaultValue={selectedFiltersValues.created_by || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'created_by')}
                  isMulti={false}
                  options={options.Users || []}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.source_id && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Source'
                  defaultValue={selectedFiltersValues.source_id || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'source_id')}
                  isMulti={false}
                  options={options.SourceType || []}
                />
              </Col>
            </InputWrapper>
          )}
          {(selectedFilters.contact_status ||
            selectedFilters.contact_assigned ||
            selectedFilters.contact_grade ||
            selectedFilters.contact_effort_level) && (
            <InputWrapper customClass='pt-0' md='6'>
              <Col md='6' className='pt-2'>
                <CustomSelect
                  label='Division'
                  defaultValue={selectedFiltersValues.contact_division_id || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'contact_division_id')}
                  isMulti={false}
                  options={options.Divisions || []}
                />
              </Col>
              {selectedFilters.contact_status && (
                <Col md='6' className='pt-2'>
                  <CustomSelect
                    label='Status'
                    disabled={selectedFiltersValues.contact_division_id === 1}
                    defaultValue={selectedFiltersValues.contact_status || null}
                    onChange={(event) => handleFiltersChanges(event, 'select', 'contact_status')}
                    isMulti={false}
                    options={contactStatusesOptions || []}
                  />
                </Col>
              )}
              {selectedFilters.contact_assigned && (
                <Col md='6' className='pt-2'>
                  <CustomSelect
                    label='Assigned'
                    disabled={selectedFiltersValues.contact_division_id === 1}
                    defaultValue={selectedFiltersValues.contact_assigned || null}
                    onChange={(event) => handleFiltersChanges(event, 'select', 'contact_assigned')}
                    isMulti={false}
                    options={options.Users || []}
                  />
                </Col>
              )}
              {selectedFilters.contact_grade && (
                <Col md='6' className='pt-2'>
                  <CustomSelect
                    label='Grade'
                    defaultValue={selectedFiltersValues.contact_grade || null}
                    onChange={(event) => handleFiltersChanges(event, 'select', 'contact_grade')}
                    isMulti={false}
                    options={options.ProspectGrade || []}
                  />
                </Col>
              )}
              {selectedFilters.contact_effort_level && (
                <Col md='6' className='pt-2'>
                  <CustomSelect
                    label='Effort Level'
                    disabled={selectedFiltersValues.contact_division_id === 1}
                    defaultValue={selectedFiltersValues.contact_effort_level || null}
                    onChange={(event) => handleFiltersChanges(event, 'select', 'contact_effort_level')}
                    isMulti={false}
                    options={options.EffortLevel || []}
                  />
                </Col>
              )}
            </InputWrapper>
          )}
          {selectedFilters.coverage_type && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Coverage Type'
                  defaultValue={selectedFiltersValues.coverage_type || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'coverage_type')}
                  isMulti={false}
                  options={[]}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.insurance_carrier && (
            <InputWrapper md='3'>
              <Col md='12'>
                <CustomSelect
                  label='Insurance Carrier'
                  defaultValue={selectedFiltersValues.insurance_carrier || null}
                  onChange={(event) => handleFiltersChanges(event, 'select', 'insurance_carrier')}
                  isMulti={false}
                  options={[]}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.exp_date && (
            <InputWrapper md='6'>
              <Col md={6}>
                <InputGroup
                  label='Insurance Expiration from'
                  name='exp_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  value={selectedFiltersValues.exp_date && selectedFiltersValues.exp_date.from}
                />
              </Col>
              <Col md={6}>
                <InputGroup
                  label='Insurance Expiration to'
                  name='exp_date'
                  type='date'
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  value={selectedFiltersValues.exp_date && selectedFiltersValues.exp_date.to}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.is_ex_yu && (
            <InputWrapper md={3}>
              <Col md={12}>
                <CustomSwitch
                  onChange={(event) => handleFiltersChanges(event)}
                  checked={!!selectedFiltersValues.is_ex_yu}
                  name={'is_ex_yu'}
                  label={'Ex-Yu'}
                  value={selectedFiltersValues?.is_ex_yu}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.name && (
            <InputWrapper md={3}>
              <Col md={12}>
                <InputGroup
                  onChange={(event) => handleFiltersChanges(event)}
                  type={'text'}
                  name={'name'}
                  label={'Name'}
                  value={selectedFiltersValues.name}
                  placeholder={''}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.number_of_trucks && (
            <InputWrapper md={3}>
              <Col md={6}>
                <InputGroup
                  onChange={(event) => handleFiltersChanges(event, 'from')}
                  type={'number'}
                  name={'number_of_trucks'}
                  label={'No. of Trucks From'}
                  value={selectedFiltersValues?.number_of_trucks?.from}
                  placeholder={''}
                  min={0}
                />
              </Col>
              <Col md={6}>
                <InputGroup
                  onChange={(event) => handleFiltersChanges(event, 'to')}
                  type={'number'}
                  name={'number_of_trucks'}
                  label={'No. of Trucks To'}
                  value={selectedFiltersValues?.number_of_trucks?.to}
                  placeholder={''}
                  min={selectedFiltersValues?.number_of_trucks?.from || 0}
                />
              </Col>
            </InputWrapper>
          )}
          {selectedFilters.exclude_accounts && (
            <InputWrapper md={3}>
              <Col md={12}>
                <CustomSelect
                  label={'Exclude Accounts'}
                  name='excludeAccounts'
                  isMulti
                  isClearable
                  options={divisions || []}
                  defaultValue={selectedFiltersValues?.excludeAccounts || []}
                  onChange={(values, event) => changeMultiSelect(values, event)}
                />
              </Col>
            </InputWrapper>
          )}
        </Row>
      </Form>
      <Row className='flex-row-reverse mr-3'>
        <Button className={'btn btn-gold'} type='submit' onClick={() => loadData({ email_status: 1 })}>
          Search
        </Button>
      </Row>
    </>
  )
}

FilterInputsEmailTemplate.propTypes = {
  selectedFilters: PropTypes.object.isRequired,
  selectedFiltersValues: PropTypes.object,
  handleFiltersChanges: PropTypes.object.isRequired,
  loadData: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  getOptions: PropTypes.func.isRequired,
}

FilterInputsEmailTemplate.defaultProps = {
  selectedFiltersValues: {},
}

export default FilterInputsEmailTemplate
